import { NgModule } from '@angular/core';
import { ExtraOptions, PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { RccV4Component } from './components/rcc-v4/rcc-v4.component';

export const HOME_ROUTE = '';

const routes: Routes = [
  { path: '', redirectTo: HOME_ROUTE, pathMatch: 'full' },
  { path: HOME_ROUTE, component: RccV4Component },
  { path: '**', redirectTo: HOME_ROUTE },
];

const routeConfig: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  scrollOffset: [0, 100],
  preloadingStrategy: PreloadAllModules,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routeConfig)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
